import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Queue } from '../../../interfaces/queue.interface';
import { QueueBatchService } from '../../../services/queue-batch.service';
import { Observable } from 'rxjs';
import { QueueBatch, QueueBatchDetailed, QueueBatchStatus } from '../../../interfaces/queue-batch.interface';
import { map } from 'rxjs/operators';
import { QueueBatchItemService } from '../../../services/queue-batch-item.service';
import { QueueBatchItem, QueueBatchItemStatus } from '../../../interfaces/queue-batch-item.interface';
import { DxiColumnModule, DxoPagingModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule, DxSelectBoxModule } from 'devextreme-angular';

@Component({
	selector: 'app-shell-admin-queue-link-overview-detailed',
	templateUrl: './admin-queue-link-overview-detailed.component.html',
	styleUrls: ['./admin-queue-link-overview-detailed.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [DxiColumnModule, DxoPagingModule, DxDataGridModule, AsyncPipe, DxSelectBoxModule]
})
export class AdminQueueLinkOverviewDetailedComponent implements OnInit {
	@Input() queue: Queue;
	@Input() rowData: any;

	queueBatches$: Observable<QueueBatchDetailed[]> = new Observable<QueueBatchDetailed[]>();
	queueBatchItems$: Observable<QueueBatchItem[]> = new Observable<QueueBatchItem[]>();

	/**
	 *
	 */
	constructor(private queueBatchService: QueueBatchService, private queueBatchItemService: QueueBatchItemService) {}

	ngOnInit(): void {
		this.queueBatches$ = this.queueBatchService.getQueueBatchByQueueId(this.queue.id).pipe(
			map((originalArray: QueueBatchDetailed[]) => {
				// Adjust the existing property (e.g., increment the age by 1)
				const adjustedArray: QueueBatchDetailed[] = originalArray.map((originalObject: QueueBatchDetailed) => {
					// Adjust the existing property (e.g., increment the age by 1)
					return {
						...originalObject,
						title:
							'[' +
							String(QueueBatchStatus[originalObject.status]) +
							'] ' +
							'Batch ' +
							originalObject.batchIndex +
							'/' +
							Math.max(...originalArray.map(o => o.batchIndex)) +
							' | Start date: ' +
							(originalObject.startDate ? this.dateToString(new Date(originalObject.startDate)) : 'Unknown') +
							' - End date: ' +
							(originalObject.endDate ? this.dateToString(new Date(originalObject.endDate)) : 'Unknown'),
					};
				});

				// Return the modified array
				return adjustedArray;
			})
		);
	}

	getEnumStringValueQueueBatchItemStatus(number: number) {
		return String(QueueBatchItemStatus[number]);
	}

	onValueChanged(item: any) {
		this.queueBatchItems$ = this.queueBatchItemService.getQueueBatchItemsByQueueBatchId(item.value);
	}

	dateToString(date_Object: Date): string {
		// get the year, month, date, hours, and minutes separately and append to the string.
		let date_String: string =
			date_Object.getDate().toString().padStart(2, '0') +
			'/' +
			(date_Object.getMonth() + 1).toString().padStart(2, '0') +
			'/' +
			date_Object.getFullYear() +
			' ' +
			date_Object.getHours().toString().padStart(2, '0') +
			':' +
			date_Object.getMinutes().toString().padStart(2, '0');
		return date_String;
	}
}
